import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import {
  Avatar,
  Button,
  createStyles,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Theme,
  Typography,
} from "@material-ui/core";
import { CameraAlt, SportsGolf, ChevronRight } from "@material-ui/icons";
import Config from "../../config";
import { ENABLE_STRIPE, ENABLE_RHI } from "../../config/featureFlags";
import UserAction from "../../actions/user";
import { switchComponent } from "../../actions/componentRouter";
import { GlobalState } from "../../types/globalState";
import { Gender, getRuleName, Rules, User } from "../../types/user";
import { buildFileSelector } from "../../utils/fileSelector";
import SearchClub from "../Search/SearchClub";
import BorderedBox from "../SharedComponents/BorderedBox";
import { Views } from "../Dashboard";
import { hideDialog } from "../SharedComponents/Dialog";
import { showAuxiliaryDialog } from "../SharedComponents/AuxiliaryDialog";
import { TextInput } from "../SharedComponents/TextInput";
import { filter } from "../../utils/profanityFilter";
import { validateEmail } from "../../utils/validator";
import { showSnackbar } from "../SharedComponents/Notifier";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/date-fns";
import { calculateAge } from "../../utils/date";
import HandicapActions from "../../actions/handicaps";

import { Handicap, IndexedHandicaps } from "types/handicap";
import { showPickerDialog } from "components/SharedComponents/PickerDialog";
import { hcpConvertor } from "utils/hcpConvertor";
import { getHandicapDisplay } from "utils";
import RHIDisplay from "./RHIDisplay";
import RHIApi from "../../api/rhi";
import StripeProfileSection from "./StripeProfileSection";
import { profileFeatureCardSurface, profileHeaderCoverSurface } from "./profileFeatureCardSurface";
import { buildProfileHandicapListings } from "../../utils/handicapListings";

interface Props extends WithStyles {
  updateMe(userInfo: any, callback?: any): void;
  switchComponent(view: any, props?: any): void;
  updateUser(userId: string, data: any, callback?: any): void;
  user: User;
  loading: boolean;
  otherUser?: boolean;
  currentUserRule?: string;
  fetchHnadicapLists(
    page: number,
    limit: number,
    filter?: any,
    sort?: string,
    dir?: string,
    query?: string,
    callback?: any,
  ): void;
  getHandicapInfo(id: string, callback?: any): void;
  updateHandicap(id: string, competitionId: string, hcp: number, playerId: string, callback?: any): any;
  handicaps: IndexedHandicaps;
}

interface StateUser extends User { }

interface State {
  [index: string]: any;
  user: StateUser;
  imageFile?: any;
  err_name: boolean;
  err_lastName: boolean;
  err_username: boolean;
  err_email: boolean;
  err_postalCode: boolean;
  err_socialHcp: boolean;
  err_hcp: boolean;
  err_cdh: boolean;
  handicapId: string;
  rhiValue: number | null;
}

const fileSelector = buildFileSelector(false, ".jpg,.png,.jpeg");

class Profile extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.props.fetchHnadicapLists(
      1,
      50,
      { player: this.props.user._id },
      "player.lastName",
      undefined,
      undefined,
      (a: any, data: any) => {
        if (!data) {
          return;
        }
        const hcps = Object.values(data).find((ha: any) => ha.player._id === this.props.user._id) as any;
        this.props.getHandicapInfo(hcps?._id ?? "", () => {
          this.setState((state: State) => ({ handicapId: hcps?._id ?? "" }));
        });
      },
    );

    this.state = {
      user: { ...props.user!, hcp: Number(getHandicapDisplay(props.user.hcp)) },
      err_name: false,
      err_lastName: false,
      err_username: false,
      err_email: false,
      err_postalCode: false,
      err_socialHcp: false,
      err_hcp: false,
      err_cdh: false,
      handicapId: "",
      rhiValue: null,
    };
    this.fetchRHI();
  }

  fetchRHI = async () => {
    const { user } = this.props;
    if (!user?._id) return;
    try {
      const response = await RHIApi.getPlayerRHI(user._id);
      const { rhi } = response.data.data;
      this.setState({ rhiValue: rhi });
    } catch (e) {
      console.error("Failed to fetch RHI", e);
    }
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.user?._id !== this.props.user?._id) {
      this.setState({ user: { ...this.props.user!, hcp: Number(getHandicapDisplay(this.props.user.hcp)) } }, () => {
        this.fetchRHI();
      });
    }
  }

  _onTextFieldChanged = (field: string) => (event: any) => {
    const value = event.target.value as string;
    this.setState((state: State) => ({ user: { ...state.user!, [field]: value ?? "" } }));
  };

  _handleTextInputChange = (value: string, name: string) => {
    this.setState((state: State) => ({ user: { ...state.user!, [name]: value ?? "" } }));
  };

  _onChangeGender = (event: any) => {
    if (event && event.target) {
      const gender = event.target.value;
      this.setState((state: State) => ({ user: { ...state.user!, gender } }));
    }
  };

  _onTitleChanged = (event: any) => {
    const name = event.target.name;
    this.setState((state: State) => ({
      user: {
        ...state.user!,
        [name]: event.target.value,
      },
    }));
  };

  _validatePostalCode(postalCode: string) {
    const separatedPC = postalCode?.split(" ");
    const firstPartRegex = /^[A-Z][A-HJ-Y]?[0-9][A-Z0-9]?$/;
    const lastPartRegex = /^(0[Aa]{2}|[0-9][A-Za-z]{2})$/i;
    if (separatedPC[0]?.match(firstPartRegex) && (!separatedPC[1] || separatedPC[1]?.length === 0)) {
      return true;
    }
    if (separatedPC[1]?.match(lastPartRegex)) {
      return true;
    }

    return false;
  }

  _validateWHSBoxes(cdhNumber: string, handicapIndex: string) {
    const hcpRegex = RegExp(/^\+?\d{1,2}(?:\.\d)?$/gm);
    let err = { hcp: false, cdh: false };

    if (this.state.user.socialHcp) {
      return err; // Skip validation if using socialHcp
    }

    // Enforce both fields are required
    if (!cdhNumber || cdhNumber.trim() === "") {
      err.cdh = true;
    } else if (!/^\d{1,10}$/.test(cdhNumber)) {
      err.cdh = true;
    }

    if (!handicapIndex || handicapIndex.trim() === "") {
      err.hcp = true;
    } else if (
      parseInt(handicapIndex) < 0 ||
      parseInt(handicapIndex) > 60 ||
      !hcpRegex.test(handicapIndex)
    ) {
      err.hcp = true;
    }

    return err;
  }

  _validateSocialHcp(socialHcp?: number) {
    if (this.state.user.hcp || this.state.user.cdh) return true;
    if (!socialHcp) return false;
    if (!Boolean(socialHcp)) {
      return true;
    }
    if (/^[0-9A-Za-z]{5}$/.test(socialHcp.toString())) {
      return false;
    } else {
      return true;
    }
  }

  //WE Need form validation on profile
  _formValidation = () => {
    const { user } = this.state;
    const { username, name, lastName, email, postalCode, socialHcp, hcp, cdh } = user!;

    const err_name = filter.isProfane(name);
    const err_lastName = filter.isProfane(lastName);
    const err_username = username.length < 5 || filter.isProfane(username);
    const err_email = !validateEmail(email);
    const err_postalCode = !this._validatePostalCode(postalCode ?? "");
    const err_socialHcp = !this._validateSocialHcp(socialHcp);

    const { hcp: err_hcp, cdh: err_cdh } = this._validateWHSBoxes(String(cdh) ?? "0", String(hcp) ?? "0");
    this.setState({ err_name, err_lastName, err_username, err_email, err_hcp, err_cdh, err_postalCode, err_socialHcp });

    console.log({
      err_name,
      err_lastName,
      err_username,
      err_email,
      err_hcp,
      err_cdh,
      err_postalCode,
      err_socialHcp,
    });

    return !(
      err_name ||
      err_lastName ||
      err_username ||
      err_email ||
      err_hcp ||
      err_cdh ||
      err_postalCode ||
      err_socialHcp
    );
  };

  _submitForm = () => {
    const { user, imageFile } = this.state;
    if (user) {
      const { name, lastName, gender, title, homeClub, dob, postalCode } = user!;
      let hcp = user.hcp;
      let cdh = user.cdh;
      let socialHcp = user.socialHcp;
      if (socialHcp) {
        hcp = undefined;
        cdh = undefined;
      } else if (hcp || cdh) {
        socialHcp = undefined;
      }
      const email = this.props.user!.email! !== user.email! ? user.email : undefined;
      const username = this.props.user!.username! !== user.username! ? user.username! : undefined;
      const dobTimestamp = dob ? Date.parse(dob.toString()) : null;
      if (this._formValidation()) {
        if (this.props.otherUser) {
          this.props.updateUser(
            user._id,
            {
              email: email?.trim(),
              username: username?.trim(),
              name: name?.trim(),
              hcp: hcp ?? "",
              gender,
              cdh: cdh ?? "",
              socialHcp,
              postalCode,
              dob: dobTimestamp,
              image: imageFile,
              lastName: lastName?.trim(),
              title,
              homeClub,
            },
            (err: any) => {
              if (!err) hideDialog();
            },
          );
        } else {
          console.log("update me");
          this.props.updateMe({
            email: email?.trim(),
            username: username?.trim(),
            name: name?.trim(),
            hcp: hcp ?? "",
            gender,
            cdh: cdh ?? "",
            socialHcp,
            postalCode,
            dob: dobTimestamp,
            image: imageFile,
            lastName: lastName?.trim(),
            title,
            homeClub,
          });
        }
      } else {
        showSnackbar("Form is not valid, check items");
      }
    }
  };

  _handleFileSelector = (event: any) => {
    this.setState({ imageFile: event.target.files[0] });
  };

  _onClickAvatar = (event: any) => {
    event.preventDefault();
    fileSelector.click();
    fileSelector.onchange = this._handleFileSelector;
  };

  _showRHIDialog = () => {
    const { user, currentUserRule } = this.props;
    showAuxiliaryDialog(
      <RHIDisplay playerId={user._id} currentUserRule={currentUserRule} inDialog />,
      "md",
      true,
      true,
      true,
      "Range Handicap Index",
    );
  };

  _onChangeHomeClub = (item: any) => {
    this.setState((state: State) => ({ user: { ...state.user!, homeClub: item } }));
  };
  _onEditClicked = (id: string, player: string, handicap: Handicap) => {
    if (!Boolean(id) || !Boolean(player)) {
      return;
    }
    showPickerDialog(
      "Handicap",
      "number",
      (hcp: string) => {
        this.props.updateHandicap(id, handicap.competitionId, parseFloat(hcpConvertor(hcp)), player);
      },
      0,
      null,
      null,
      false,
      true,
    );
  };

  getAvatar = (user: any) => {
    const { imageFile } = this.state;
    let avatar = require("../../assets/images/icons/question_mark_200px.png");

    if (imageFile) {
      avatar = URL.createObjectURL(imageFile);
    } else if (user.avatar) {
      avatar = Config.API_URL + user.avatar;
    } else if (user.gender === Gender.Men) {
      avatar = require("../../assets/images/icons/avatar_men.png");
    } else if (user.gender === Gender.Women) {
      avatar = require("../../assets/images/icons/avatar_women.png");
    } else if (user.rule === Rules.ClubManager) {
      avatar = require("../../assets/images/icons/house_100px.png");
    }
    return avatar;
  };
  renderActionButton = () => {
    const { loading, classes } = this.props;
    return (
      <div className={classes.actionColumn}>
        {loading ? <LinearProgress className={classes.footerProgress} /> : null}
        <div className={classes.buttonRow}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            disableElevation
            className={classes.saveButton}
            onClick={this._submitForm}
            disabled={loading}
          >
            Save changes
          </Button>
          <Button
            fullWidth
            variant="outlined"
            className={classes.backButton}
            disabled={loading}
            onClick={() => {
              if (this.props.otherUser) {
                hideDialog();
              } else {
                this.props.switchComponent(Views.DEFAULT);
              }
            }}
          >
            Back
          </Button>
        </div>
      </div>
    );
  };
  render() {
    const { classes, user } = this.props;
    const {
      err_name,
      err_lastName,
      err_username,
      err_email,
      err_postalCode,
      err_socialHcp,
      err_cdh,
      err_hcp,
      handicapId,
    } = this.state;
    const {
      name,
      username,
      lastName,
      title,
      homeClub,
      cdh,
      hcp,
      dob,
      email,
      gender,
      rule,
      socialHcp,
      postalCode,
      shcp,
      rhi
    } = this.state.user;
    let defaultHomeClub = homeClub || null;
    const handicap = this.props.handicaps[handicapId];
    const hideStripeSection = !ENABLE_STRIPE || !!this.props.otherUser || this.props.currentUserRule === Rules.Player;
    const { loading } = this.props;
    const { rhiValue } = this.state;
    const handicapListings = buildProfileHandicapListings(
      socialHcp ? undefined : hcp,
      handicap?.handicaps ?? [],
    );
    return (
      <div className={classes.page}>
        <div className={classes.pageHeader}>
          <Typography variant="h5" component="h1" className={classes.pageTitle}>
            Profile
          </Typography>
          <Typography variant="body2" color="textSecondary" className={classes.pageSubtitle}>
            Update your details, handicap, and how you receive game payments.
          </Typography>
        </div>

        <Paper className={classes.sheet} elevation={0}>
          <div className={classes.avatarSection}>
            <div className={classes.avatarContainer}>
              <Avatar
                className={classes.avatarLarge}
                src={this.getAvatar(user)}
                imgProps={{ alt: "" }}
              />
              <IconButton onClick={this._onClickAvatar} className={classes.cameraButton} size="small" aria-label="Change profile photo">
                <CameraAlt className={classes.cameraIcon} />
              </IconButton>
            </div>
            <div className={classes.avatarMeta}>
              <Typography variant="h6" className={classes.avatarName}>
                {[name, lastName].filter(Boolean).join(" ").trim() || username || "User"}
              </Typography>
              <Typography variant="caption" color="textSecondary" className={classes.avatarRole}>
                {getRuleName(rule)}
              </Typography>
            </div>
          </div>

          <Divider className={classes.rule} />

          <div className={classes.section}>
            <Typography variant="overline" className={classes.sectionLabel}>
              Sign-in
            </Typography>
            <div className={classes.fieldStack}>
            <TextInput
              type="text"
              label={"Username"}
              value={username}
              variant={"outlined"}
              fullWidth
              error={err_username}
              name={"username"}
              onChange={this._handleTextInputChange}
            />
            <TextInput
              type="text"
              label={"Email"}
              value={email}
              variant={"outlined"}
              fullWidth
              error={err_email}
              disableProfanityCheck
              name={"email"}
              onChange={this._handleTextInputChange}
            />
            </div>
          </div>

          <Divider className={classes.rule} />

          <div className={classes.section}>
            <Typography variant="overline" className={classes.sectionLabel}>
              Club
            </Typography>
            <BorderedBox title={"Home club"} variant={"h6"} padding={"none"} fullWidth className={classes.profileBorderedBox}>
              <SearchClub dialog defaultSelectedItem={defaultHomeClub} onClubSelected={this._onChangeHomeClub} />
            </BorderedBox>
          </div>

          <Divider className={classes.rule} />

          <div className={classes.section}>
            <Typography variant="overline" className={classes.sectionLabel}>
              Personal
            </Typography>
            <div className={classes.fieldStack}>
            <div className={classes.formRow}>
              <div className={classes.genderField}>
                <FormLabel component="legend" className={classes.genderLabel}>Gender</FormLabel>
                <RadioGroup
                  defaultValue={gender}
                  aria-label="gender"
                  onChange={this._onChangeGender}
                  row
                  className={classes.genderRadioGroup}
                >
                  <FormControlLabel value="men" control={<Radio />} label="Male" />
                  <FormControlLabel value="women" control={<Radio />} label="Female" />
                </RadioGroup>
              </div>
            </div>
            <div className={classes.formRow}>
              <TextField fullWidth disabled type="text" label={"SURN"} variant="outlined" value={user.createDate ?? ""} />
            </div>
            <div className={classes.formRow}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor={"title-label"}>Title</InputLabel>
                <Select
                  label="Title"
                  inputProps={{ name: "title", id: "title-label" }}
                  value={title}
                  fullWidth
                  onChange={this._onTitleChanged}
                >
                  <MenuItem value={"Mr"}>Mr</MenuItem>
                  <MenuItem value={"Mrs"}>Mrs</MenuItem>
                  <MenuItem value={"Miss"}>Miss</MenuItem>
                </Select>
              </FormControl>
              <TextInput
                type="text"
                label={"First name"}
                value={name}
                fullWidth
                variant={"outlined"}
                error={err_name}
                captalize
                name={"name"}
                onChange={this._handleTextInputChange}
              />
            </div>
            <div className={classes.formRow}>
              <TextInput
                type="text"
                label={"Last name"}
                value={lastName}
                fullWidth
                variant={"outlined"}
                error={err_lastName}
                captalize
                name={"lastName"}
                onChange={this._handleTextInputChange}
              />
              <TextInput
                type="text"
                label={"Postcode"}
                value={postalCode}
                fullWidth
                variant={"outlined"}
                error={err_postalCode}
                captalize
                name={"postalCode"}
                onChange={this._handleTextInputChange}
              />
            </div>
            <div className={classes.formRow}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <KeyboardDatePicker
                  id="date"
                  variant="dialog"
                  label="Date of birth"
                  format="dd/MM/yyyy"
                  margin="none"
                  fullWidth
                  inputVariant="outlined"
                  value={dob || null}
                  onChange={(date: Date | null) =>
                    //@ts-ignore
                    this.setState((state: State) => ({ user: { ...state.user!, dob: date } }))
                  }
                />
              </MuiPickersUtilsProvider>
              <TextField
                type="number"
                label={"Age"}
                value={calculateAge(dob ? new Date(dob) : null)}
                fullWidth
                disabled={true}
                variant={"outlined"}
              />
            </div>
            </div>
          </div>

          <Divider className={classes.rule} />

          <div className={classes.section}>
            <Typography variant="overline" className={classes.sectionLabel}>
              Handicap
            </Typography>
            <div className={classes.fieldStack}>
            <div className={classes.formRow}>
              <TextField
                type="text"
                label={"WHS Handicap Index"}
                value={
                  this.state.user.shcp && this.state.user.socialHcp && this.state.user.hcp ? "" : String(hcp)
                }
                fullWidth
                variant={"outlined"}
                error={err_hcp}
                inputProps={{ min: 0, max: 54 }}
                onChange={this._onTextFieldChanged("hcp")}
                disabled={Boolean(socialHcp)} // Disable if socialHcp is present
              />
              <TextField
                type="number"
                label={"WHS CDH No."}
                value={
                  this.state.user.shcp && this.state.user.socialHcp && this.state.user.cdh ? "" : String(cdh)
                }
                fullWidth
                error={err_cdh}
                variant={"outlined"}
                onChange={this._onTextFieldChanged("cdh")}
                disabled={Boolean(socialHcp)} // Disable if socialHcp is present
              />
            </div>
            <div className={classes.formRow}>
              <TextField
                disabled={(Boolean(hcp) || Boolean(cdh)) && !Boolean(shcp)} // Disable if
                type="text"
                label={"Social H/Cap"}
                value={socialHcp}
                fullWidth
                variant={"outlined"}
                error={err_socialHcp}
                name={"socialHcp"}
                onChange={this._onTextFieldChanged("socialHcp")}
              />

              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor={"all-hcp's-label"}>All H/Caps & Indexes</InputLabel>
                <Select
                  label="All H/Caps & Indexes"
                  inputProps={{ name: "all-hcp's", id: "all-hcp's-label" }}
                  value={""}
                  fullWidth
                // onChange={() =>
                //   this._onEditClicked(handicap?._id ?? "", handicap?.player._id ?? "", handicap?.handicaps)
                // }
                >
                  {handicapListings.length > 0 ? (
                    handicapListings.map(entry => (
                      <MenuItem
                        key={entry.key}
                        value={entry.key}
                        style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "8px" }}
                      >
                        <Typography>{getHandicapDisplay(entry.hcp)}.&nbsp;</Typography>
                        <Typography>{entry.label}</Typography>
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                      <Typography>None</Typography>
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
            {ENABLE_RHI ? (
              <Paper className={classes.rhiCard} elevation={0} component="div">
                <Button
                  fullWidth
                  className={classes.rhiButtonInner}
                  onClick={this._showRHIDialog}
                  disabled={loading}
                >
                  <div className={classes.rhiButtonContent}>
                    <div className={classes.rhiButtonLeft}>
                      <div className={classes.rhiIconBadge}>
                        <SportsGolf className={classes.rhiIconBadgeSvg} />
                      </div>
                      <div>
                        <Typography variant="caption" color="textSecondary" display="block" className={classes.rhiLabel}>
                          Range Handicap Index (RHI)
                        </Typography>
                        <Typography variant="body1" className={classes.rhiValue}>
                          {rhiValue !== null && rhiValue !== undefined ? rhiValue.toFixed(1) : "—"}
                        </Typography>
                      </div>
                    </div>
                    <div className={classes.rhiButtonRight}>
                      <Typography variant="caption" className={classes.rhiCta}>
                        Details
                      </Typography>
                      <ChevronRight className={classes.rhiChevron} />
                    </div>
                  </div>
                </Button>
              </Paper>
            ) : null}
            </div>
          </div>

          {!hideStripeSection ? (
            <>
              <Divider className={classes.rule} />
              <div className={classes.section}>
                <Typography variant="overline" className={classes.sectionLabel}>
                  Payment
                </Typography>
                <StripeProfileSection disabled={false} />
              </div>
            </>
          ) : null}

          <div className={classes.footerArea}>{this.renderActionButton()}</div>
        </Paper>
      </div>
    );
  }
}

/** Radius scale (mobile-first): surfaces 10px, sm+ 12px; icon tiles 10px; controls 10px */
const styles = (theme: Theme) =>
  createStyles({
    page: {
      boxSizing: "border-box",
      width: "100%",
      maxWidth: "100%",
      margin: 0,
      minWidth: 0,
      padding: theme.spacing(1.5, 1.5, 3),
      height: "auto",
      minHeight: 0,
      flexShrink: 0,
      [theme.breakpoints.up("sm")]: {
        maxWidth: 680,
        margin: "0 auto",
        padding: theme.spacing(2, 2, 4),
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: 920,
        padding: theme.spacing(2.5, 3, 4.5),
      },
    },
    pageHeader: {
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        marginBottom: theme.spacing(2.5),
      },
    },
    pageTitle: {
      fontWeight: 600,
      letterSpacing: "-0.02em",
      fontSize: "1.35rem",
      lineHeight: 1.25,
      color: theme.palette.type === "dark" ? theme.palette.grey[100] : theme.palette.grey[900],
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.5rem",
      },
    },
    pageSubtitle: {
      marginTop: theme.spacing(0.5),
      lineHeight: 1.45,
      maxWidth: "36rem",
      fontSize: "0.875rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: "1rem",
      },
    },
    sheet: {
      borderRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      overflow: "visible",
      "& .MuiOutlinedInput-root": {
        borderRadius: 10,
        [theme.breakpoints.up("sm")]: {
          borderRadius: 12,
        },
      },
      [theme.breakpoints.up("sm")]: {
        borderRadius: 12,
      },
    },
    avatarSection: {
      ...profileHeaderCoverSurface(theme),
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: theme.spacing(1.5),
      padding: theme.spacing(2, 1.5, 1.5),
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      [theme.breakpoints.up("sm")]: {
        gap: theme.spacing(2),
        padding: theme.spacing(3, 2.5, 2),
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
      },
    },
    avatarContainer: {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
    },
    avatarLarge: {
      width: 100,
      height: 100,
      border: `3px solid ${theme.palette.type === "dark" ? "rgba(15, 23, 42, 0.9)" : "#ffffff"}`,
      boxShadow: `0 2px 8px ${theme.palette.type === "dark" ? "rgba(0,0,0,0.35)" : "rgba(15, 23, 42, 0.1)"}`,
    },
    cameraButton: {
      position: "absolute",
      bottom: 0,
      right: 0,
      width: 32,
      height: 32,
      minWidth: 32,
      minHeight: 32,
      padding: 0,
      transform: "translate(26%, 26%)",
      borderRadius: 10,
      backgroundColor: theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.35)" : "rgba(71, 85, 105, 0.85)",
      border: `2px solid ${theme.palette.type === "dark" ? "rgba(15, 23, 42, 0.9)" : "#ffffff"}`,
      "&:hover": {
        backgroundColor: theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.5)" : "rgba(51, 65, 85, 0.92)",
      },
    },
    cameraIcon: {
      color: theme.palette.common.white,
      fontSize: 18,
    },
    avatarMeta: {
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      flex: 1,
    },
    avatarName: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
      lineHeight: 1.2,
    },
    avatarRole: {
      marginTop: theme.spacing(0.5),
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
    rule: {
      margin: 0,
    },
    section: {
      padding: theme.spacing(1.5, 1.5),
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2, 2.5),
      },
    },
    sectionLabel: {
      display: "block",
      letterSpacing: "0.12em",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1.5),
    },
    fieldStack: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1.5),
      [theme.breakpoints.up("sm")]: {
        gap: theme.spacing(2),
      },
    },
    footerArea: {
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(2, 1.5, 2.5),
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2.5, 2.5, 3),
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
      },
    },
    actionColumn: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      width: "100%",
    },
    footerProgress: {
      width: "100%",
      borderRadius: 2,
    },
    rhiCard: {
      ...profileFeatureCardSurface(theme),
      borderRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up("sm")]: {
        borderRadius: 12,
      },
    },
    rhiButtonInner: {
      textTransform: "none",
      padding: theme.spacing(1.75, 2),
      borderRadius: 0,
      justifyContent: "stretch",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor:
          theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.08)" : "rgba(15, 23, 42, 0.04)",
      },
    },
    rhiButtonContent: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      gap: theme.spacing(1),
    },
    rhiButtonLeft: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      minWidth: 0,
      textAlign: "left",
    },
    rhiIconBadge: {
      width: 44,
      height: 44,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      backgroundColor: theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.12)" : "rgba(15, 23, 42, 0.06)",
      border: `1px solid ${theme.palette.type === "dark" ? "rgba(148, 163, 184, 0.2)" : "rgba(15, 23, 42, 0.08)"}`,
    },
    rhiIconBadgeSvg: {
      fontSize: 22,
      color: theme.palette.type === "dark" ? theme.palette.grey[300] : theme.palette.grey[800],
    },
    rhiLabel: {
      letterSpacing: "0.02em",
    },
    rhiValue: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    rhiButtonRight: {
      display: "flex",
      alignItems: "center",
      gap: 2,
      flexShrink: 0,
    },
    rhiCta: {
      fontWeight: 600,
      letterSpacing: "0.06em",
      color: theme.palette.text.secondary,
    },
    rhiChevron: {
      fontSize: 20,
      color: theme.palette.text.secondary,
      opacity: 0.8,
    },
    buttonRow: {
      display: "flex",
      flexDirection: "column-reverse",
      gap: theme.spacing(1.25),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
        gap: theme.spacing(1.5),
      },
    },
    saveButton: {
      textTransform: "none",
      fontWeight: 600,
      borderRadius: 10,
      padding: theme.spacing(1.25, 1.75),
      minHeight: 48,
      [theme.breakpoints.up("sm")]: {
        borderRadius: 12,
        padding: theme.spacing(1.25, 2),
      },
    },
    backButton: {
      textTransform: "none",
      fontWeight: 600,
      borderRadius: 10,
      padding: theme.spacing(1.25, 1.75),
      minHeight: 48,
      borderColor: theme.palette.divider,
      [theme.breakpoints.up("sm")]: {
        borderRadius: 12,
        padding: theme.spacing(1.25, 2),
      },
    },
    formRow: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        gap: theme.spacing(2),
      },
    },
    genderField: {
      width: "100%",
      borderRadius: 10,
      padding: "10px 18px 10px",
      minHeight: 56,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.up("sm")]: {
        borderRadius: 12,
      },
    },
    genderLabel: {
      fontSize: "0.8rem",
      marginBottom: theme.spacing(0.25),
      color: theme.palette.text.secondary,
    },
    genderRadioGroup: {
      marginLeft: -10,
      marginTop: 0,
      marginBottom: 0,
    },
    fullWidth: {
      width: "100%",
    },
    profileBorderedBox: {
      width: "100%",
      "& fieldset": {
        borderRadius: 10,
        [theme.breakpoints.up("sm")]: {
          borderRadius: 12,
        },
      },
    },
  });

const mapStateToProps = (state: GlobalState, props: any) => {
  const { user } = state.auth;
  const { handicaps } = state.handicaps;

  const { loading } = state.general;
  return {
    loading,
    handicaps: handicaps ?? [],
    user: props.user || user,
    currentUserRule: user?.rule,
  };
};

export default connect(mapStateToProps, {
  updateMe: UserAction.updateMe,
  updateUser: UserAction.updateUser,
  fetchHnadicapLists: HandicapActions.fetch,
  getHandicapInfo: HandicapActions.getHandicapInfo,
  updateHandicap: HandicapActions.updateHandicap,
  switchComponent,
})(withStyles(styles)(Profile));
